module.exports = {"id":"210603","name":"Yasser Al Shahrani","rating":"74","photo":"./data/images/photos/2/210603.png","club":{"name":"Al Hilal","logo":"./data/images/clubs/AlHilal.png"},"positions":["DG","DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YasserAlShahrani0.json
// module id = 4393
// module chunks = 0